import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Using the same base URL approach as researchReportSlice
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';

export const parseReportFile = createAsyncThunk(
    "upload/parseReportFile",
    async (file, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            formData.append("file", file);

            const response = await axios.post(
                `${API_BASE_URL}/admin/reports/parse`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );

            return response.data.data ? response.data.data : response.data;
        } catch (err) {
            console.error("Error parsing file:", err);
            if (err.response && err.response.data) {
                return rejectWithValue(err.response.data);
            }
            return rejectWithValue(err.message);
        }
    }
);

const uploadSlice = createSlice({
    name: "upload",
    initialState: {
        parsedData: null,
        loading: false,
        error: null,
        success: false,
    },
    reducers: {
        resetUploadState: (state) => {
            state.parsedData = null;
            state.loading = false;
            state.error = null;
            state.success = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(parseReportFile.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
                state.parsedData = null;
            })
            .addCase(parseReportFile.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.parsedData = action.payload;
            })
            .addCase(parseReportFile.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Failed to parse file";
                state.success = false;
            });
    },
});

export const { resetUploadState } = uploadSlice.actions;

export default uploadSlice.reducer;
